export default __webpack_public_path__ + "static/Justin Headshot-d4ad8f32b77612632c9bd49265f439ba.png";